import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import Button from '../Button';
import MonetizedLink from '../MonetizedLink';
import ShowOnly from '../ShowOnly';
import Text from '../Text';

import * as styles from './HeaderLinks.module.less';

const HeaderLinks = ({ links, headerButton }) => {
  return (
    <>
      {/* Links */}
      {links && links.length > 0 && (
        <ul className={styles.headerLinks}>
          {links.map(link => (
            <ShowOnly
              component="li"
              key={link.text}
              minBreakpoint={link.minBreakpoint || 'all'}
            >
              <a href={link.path} className={styles.link}>
                {link.text}
              </a>
            </ShowOnly>
          ))}
        </ul>
      )}
      {headerButton && headerButton.text && (
        <MonetizedLink
          href={headerButton.url}
          ignoreRank
          ignoreMvisit
          componentType="PrimaryNav"
          component={({ href, children, ...props }) => (
            <Button
              isLink
              linkHref={href}
              size="small"
              btnType="primary"
              className={styles.button}
              {...props}
            >
              <Text className={styles.button}>{children}</Text>
            </Button>
          )}
        >
          {headerButton.text}
        </MonetizedLink>
      )}
    </>
  );
};

HeaderLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      text: PropTypes.string,
      childItems: PropTypes.arrayOf(
        PropTypes.shape({ url: PropTypes.string, text: PropTypes.string })
      ),
    })
  ),
  headerButton: PropTypes.shape({
    url: PropTypes.string,
    text: PropTypes.string,
    icon: PropTypes.string,
  }),
};

HeaderLinks.defaultProps = {
  links: [],
  headerButton: null,
};

export default HeaderLinks;
